import PropTypes from "prop-types";
import React, { PureComponent } from "react";

export default class Choice extends PureComponent {
  static propTypes = {
    id: PropTypes.any,
    label: PropTypes.string,
    note: PropTypes.string,
    handleClick: PropTypes.func,
    checked: PropTypes.bool
  };

  static defaultProps = {
    handleClick: () => {},
    checked: false
  };

  render() {
    const { checked, label, note, handleClick, id } = this.props;

    return (
      <div className="ChoiceCard">
        <div
          id={"id"}
          tabIndex="0"
          checked={checked}
          className={"Choice"}
          onClick={handleClick}
          role={"button"}
        >
          <div className="Choice__graphic">
            <div className="Choice__graphic__outer" />
            <div className="Choice__graphic__inner" />
          </div>
          <div className={"Choice__content"}>
            <span className="Choice__label">{label}</span>
          </div>
          <span className="Choice__note">{note}</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Choices/Choice.js